import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import RequestsManagerPage from "../../PagesManager/RequestsManagerPage";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import loadConfig from "../../Services/apiService";


const RequestsManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };


  
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="الطلبات"
        child={[<RequestsManagerPage  />]}
      />
    </>
  );
};
export default RequestsManager;
